import { render, staticRenderFns } from "./AttachmentPosting.vue?vue&type=template&id=b2147ac2"
import script from "./AttachmentPosting.vue?vue&type=script&lang=js"
export * from "./AttachmentPosting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports